import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DeviceService {
  async getDeviceInfo() {
    // 1. Get Battery Info (if supported)
    let batteryInfo = {};
    try {
      const battery = await (navigator as any).getBattery?.();
      if (battery) {
        batteryInfo = {
          level: battery.level * 100 + '%',
          charging: battery.charging,
        };
      }
    } catch (e) {}

    // 2. Get High Entropy User Agent Data (Modern Browsers)
    let highEntropyData = {};
    if ((navigator as any).userAgentData) {
      try {
        highEntropyData = await (
          navigator as any
        ).userAgentData.getHighEntropyValues([
          'model',
          'platformVersion',
          'fullVersionList',
          'architecture',
        ]);
      } catch (e) {}
    }

    // 3. Get Storage Estimate
    let storageInfo = {};
    try {
      const estimate = await navigator.storage.estimate();
      storageInfo = {
        quotaMB: Math.round((estimate.quota || 0) / 1024 / 1024),
        usageMB: Math.round((estimate.usage || 0) / 1024 / 1024),
      };
    } catch (e) {}

    // 4. Scrape GPU (Crucial for identifying iPhone models)
    let gpu = 'unknown';
    try {
      const canvas = document.createElement('canvas');
      const gl =
        canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
      if (gl) {
        const debugInfo = (gl as any).getExtension('WEBGL_debug_renderer_info');
        gpu = (gl as any).getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
      }
    } catch (e) {}

    return {
      // Identity & Browser
      userAgent: navigator.userAgent,
      ...highEntropyData,
      language: navigator.language,
      platform:
        (navigator as any).userAgentData?.platform || navigator.platform,

      // Display
      screen: {
        width: window.screen.width,
        height: window.screen.height,
        availWidth: window.screen.availWidth,
        availHeight: window.screen.availHeight,
        colorDepth: window.screen.colorDepth,
        devicePixelRatio: window.devicePixelRatio,
        orientation: screen.orientation?.type || 'unknown',
      },

      // Hardware
      hardware: {
        cores: navigator.hardwareConcurrency || 'unknown',
        memory: (navigator as any).deviceMemory || 'unknown',
        maxTouchPoints: navigator.maxTouchPoints,
        gpu: gpu,
      },

      // Status & Connectivity
      battery: batteryInfo,
      storage: storageInfo,
      network: {
        effectiveType:
          (navigator as any).connection?.effectiveType || 'unknown',
        saveData: (navigator as any).connection?.saveData || false,
        downlink: (navigator as any).connection?.downlink || 'unknown',
      },

      // Context
      url: window.location.href,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      timestamp: new Date().toISOString(),
    };
  }
}
